
export default {
  quickStart(state: any, quickStart: boolean) {
    state.tutorial.quickStart = quickStart;
  },

  quickStartStep(state: any, quickStartStep: any) {
    state.tutorial.quickStartStep = quickStartStep;
  },

  quickStartHiddenClass(state: any, quickStartHiddenClass: boolean) {
    state.tutorial.quickStartHiddenClass = quickStartHiddenClass;
  },

  quickStartSection(state: any, quickStartSection: any) {
    state.tutorial.quickStartSection = quickStartSection;
  },
};
